import axios from 'axios';
import Cookies from 'js-cookie';

// ==================== CONFIGURE AXIOS GLOBALLY ====================
// This ensures ALL axios requests include credentials (cookies)
axios.defaults.withCredentials = true;
axios.defaults.headers.common['Content-Type'] = 'application/json';

// Function to get CSRF token from cookie
export const getCsrfToken = () => {
  return Cookies.get('csrftoken') || '';
};

// Function to fetch CSRF token from backend
export const fetchCsrfToken = async () => {
  try {
    const response = await fetch('/authentication/csrf/', {
      method: 'GET',
      credentials: 'include', // Important for cookies
    });
    
    if (response.ok) {
      // The token should now be in the cookie
      return getCsrfToken();
    }
  } catch (error) {
    console.error('Failed to fetch CSRF token:', error);
  }
  return '';
};

// Axios configuration helper
export const axiosConfig = (includeCsrf = true) => ({
  headers: {
    'Content-Type': 'application/json',
    ...(includeCsrf && { 'X-CSRFToken': getCsrfToken() }),
  },
  withCredentials: true, // Ensure cookies are sent
});

// ==================== AXIOS INTERCEPTOR ====================
// Automatically add CSRF token to all non-GET requests
axios.interceptors.request.use(
  (config) => {
    // Add CSRF token for state-changing requests
    if (['post', 'put', 'patch', 'delete'].includes(config.method?.toLowerCase())) {
      const csrfToken = getCsrfToken();
      if (csrfToken) {
        config.headers['X-CSRFToken'] = csrfToken;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
